import React from 'react';
import InputField, { shared as inputFieldSharedMethods, } from '..';
const Messages = ({ errorMessage, supportMessage, prefix, id, }) => {
    // Derived values
    const errorMessageId = inputFieldSharedMethods.errorMessageId({
        prefix,
        id,
    });
    const supportMessageId = `${prefix}-supportMessage-${id}`;
    return (React.createElement(React.Fragment, null,
        errorMessage && (React.createElement(InputField.ErrorMessage, { id: errorMessageId, errorMessage: errorMessage, "data-testid": errorMessageId })),
        !errorMessage && supportMessage && (React.createElement(InputField.SupportMessage, { id: supportMessageId, supportMessage: supportMessage, "data-testid": supportMessageId }))));
};
Messages.displayName = 'Messages';
export default Messages;
//# sourceMappingURL=index.js.map